import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/home/logo_orange.png'
import _imports_1 from '../assets/home/logo_branco.svg'
import _imports_2 from '../assets/home/missao.png'
import _imports_3 from '../assets/home/valores.png'
import _imports_4 from '../assets/home/torre.jpg'
import _imports_5 from '../assets/home/linkedin.png'


const _withScopeId = n => (_pushScopeId("data-v-7454bbd8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "header",
  class: "row justify-between wrap"
}
const _hoisted_2 = {
  id: "toolbar",
  class: "flex row justify-around"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  id: "logo",
  src: _imports_0,
  alt: "Logo"
}, null, -1))
const _hoisted_4 = {
  id: "menu",
  class: "row items-center"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "banner",
  class: "column flex-center items-center"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    style: {"width":"92px"},
    src: _imports_1
  }),
  /*#__PURE__*/_createElementVNode("p", { style: {"color":"white","margin-bottom":"-10px","text-align":"center","font-size":"28px","margin-top":"10px","letter-spacing":"5px"} }, [
    /*#__PURE__*/_createTextVNode("SOBRE A "),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"#e94f37","font-weight":"bolder"} }, "STUDIOAPP")
  ]),
  /*#__PURE__*/_createElementVNode("hr", { style: {"border":"1px white","border-style":"none none dotted","width":"350px"} }),
  /*#__PURE__*/_createElementVNode("p", { id: "textbanner" }, [
    /*#__PURE__*/_createTextVNode(" A "),
    /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"bolder"} }, "studioApp"),
    /*#__PURE__*/_createTextVNode(" é uma empresa do ramo de "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" tecnologia, especializada no desenvolvimento de "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" soluções e serviços que priorizam a qualidade, a "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" praticidade e a inovação, sempre se adequando às "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" necessidades de cada cliente e garantindo a eles "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" total segurança e tranquilidade.")
  ])
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"background-color":"#e94f37","height":"5px"} }, null, -1))
const _hoisted_7 = {
  class: "row flex items-baseline justify-center",
  id: "missao"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-center column" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"font-weight":"bolder","font-size":"28px","letter-spacing":"5px","text-transform":"uppercase","line-height":"1px","text-align":"center"} }, " Missão"),
  /*#__PURE__*/_createElementVNode("hr", { style: {"border":"1px black","border-style":"none none dotted","width":"150px","margin-top":"1px"} }),
  /*#__PURE__*/_createElementVNode("img", {
    style: {"width":"42px","margin-bottom":"10px","margin-top":"10px"},
    src: _imports_2,
    alt: "Missão"
  }),
  /*#__PURE__*/_createElementVNode("p", { id: "textomissao" }, [
    /*#__PURE__*/_createTextVNode("Buscar a excelência no desenvolvimento de soluções inteligentes, criativas e inovadoras através do uso e da criação de ferramentas computacionais que permitam a elaboração de sistemas complexos com qualidade, rapidez e transparência. Dispor para isso de um quadro técnico com elevada experiência e conhecimento. "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Propiciar um ambiente de trabalho estimulante e diversificado, visando atrair, capacitar e reter os melhores talentos.")
  ])
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "vl" }, null, -1))
const _hoisted_10 = { class: "valores flex column items-center" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"font-weight":"bolder","font-size":"28px","letter-spacing":"5px","text-transform":"uppercase","line-height":"1px","text-align":"center"} }, " VALORES", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { style: {"border":"1px black","border-style":"none none dotted","width":"150px","margin-top":"1px"} }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"42px","margin-top":"10px","margin-bottom":"10px"},
  src: _imports_3,
  alt: "Valores"
}, null, -1))
const _hoisted_14 = /*#__PURE__*/_createTextVNode("INTEGRIDADE NOS NEGÓCIOS")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("INOVAÇÃO NAS SOLUÇÕES")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("EXCELÊNCIA NOS SERVIÇOS PRESTADOS")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("RESPEITO AO PRÓXIMO")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("MERITOCRACIA COM OS COLABORADORES")
const _hoisted_19 = {
  id: "expert",
  class: "flex items-center column"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { id: "expert_title" }, [
  /*#__PURE__*/_createTextVNode("NOSSAS "),
  /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"bolder"} }, "EXPERTISES")
], -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { id: "hr_expert" }, null, -1))
const _hoisted_22 = {
  id: "grid",
  class: "flex justify-center"
}
const _hoisted_23 = { style: {"min-height":"70px"} }
const _hoisted_24 = ["src"]
const _hoisted_25 = { style: {"min-height":"30px"} }
const _hoisted_26 = { style: {"text-align":"center","min-height":"200px"} }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"bolder","font-size":"24px","line-height":"1px"} }, "...", -1))
const _hoisted_28 = {
  id: "portfolio",
  class: "flex column items-center"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"28px","text-align":"center","letter-spacing":"10px"} }, [
  /*#__PURE__*/_createTextVNode("PORTFÓLIO "),
  /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"bolder"} }, " STUDIOAPP")
], -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { id: "hr_port" }, null, -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { id: "port_text" }, [
  /*#__PURE__*/_createTextVNode("A "),
  /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"bolder"} }, "studioApp"),
  /*#__PURE__*/_createTextVNode(" vem desenvolvendo diversos "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" aplicativos e programas voltados principalmente "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ao setor elétrico brasileiro, seja utilizando sua própria expertise "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ou através de parcerias com renomadas universidades, via projetos de P&D.")
], -1))
const _hoisted_32 = {
  id: "grid_port",
  class: "flex justify-center"
}
const _hoisted_33 = {
  class: "card column items-center",
  style: {"background-color":"#cfcac6","width":"300px","height":"250px","padding-top":"20px","border-top":"black solid 5px"}
}
const _hoisted_34 = { style: {"min-height":"80px"} }
const _hoisted_35 = ["width", "id", "src"]
const _hoisted_36 = { style: {"margin-top":"5px","font-size":"16px"} }
const _hoisted_37 = ["href"]
const _hoisted_38 = /*#__PURE__*/_createTextVNode("Saiba mais ")
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"background-color":"#e94f37","height":"5px"} }, null, -1))
const _hoisted_40 = {
  id: "footer",
  class: "flex column items-center"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"color":"white","font-size":"28px","text-align":"center","letter-spacing":"10px"} }, "FALE CONOSCO", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { style: {"border":"1px white","border-style":"none none dotted","width":"350px","margin-top":"-15px"} }, null, -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { id: "footer_text" }, [
  /*#__PURE__*/_createTextVNode("Caso necessite de mais informações a respeito de nossos produtos e serviços, "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" entre em contato pelo formulário abaixo. Teremos o maior prazer em atendê-lo.")
], -1))
const _hoisted_44 = {
  id: "form",
  class: "column"
}
const _hoisted_45 = {
  class: "form_field",
  style: {"margin-right":"10px"}
}
const _hoisted_46 = { class: "form_field" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { style: {"border":"1px white","border-style":"none none dotted","width":"60%","margin-top":"20px","margin-bottom":"20px"} }, null, -1))
const _hoisted_48 = {
  id: "rodape",
  class: "row flex items-center"
}
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"128px"},
  src: _imports_1,
  alt: "Logo"
}, null, -1))
const _hoisted_50 = [
  _hoisted_49
]
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {"margin-left":"50px","margin-right":"100px"},
  class: "column"
}, [
  /*#__PURE__*/_createElementVNode("p", { style: {"color":"white"} }, [
    /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"bolder"} }, "Endereço"),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Rua Ataliba de Barros, nº 182, sl 1604 "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" São Mateus - Juiz de Fora - MG - Brasil "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" CEP: 36025-275 ")
  ]),
  /*#__PURE__*/_createElementVNode("div", {
    style: {"width":"100%"},
    class: "row"
  }, [
    /*#__PURE__*/_createElementVNode("p", { style: {"color":"white"} }, [
      /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"bolder"} }, "E-mail"),
      /*#__PURE__*/_createTextVNode(),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" contato@studioapp.com.br ")
    ])
  ])
], -1))
const _hoisted_52 = { class: "column flex" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"100%","text-align":"end","margin-top":"40px","margin-bottom":"40px"} }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.linkedin.com/company/studioapp/",
    target: "_blank"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      style: {"width":"36px","height":"36px"},
      src: _imports_5,
      alt: "Linkedin"
    })
  ])
], -1))
const _hoisted_54 = { class: "flex items-center column" }
const _hoisted_55 = { style: {"color":"white"} }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  style: {"text-decoration":"none","align-self":"end","margin-right":"3%"},
  href: "https://www.amaiscriacao.com.br/",
  target: "_blank"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "row flex items-center" }, [
    /*#__PURE__*/_createElementVNode("p", { style: {"color":"white","margin-top":"12px","margin-right":"5px","font-size":"10px"} }, "Designed by"),
    /*#__PURE__*/_createElementVNode("img", {
      style: {"width":"20px"},
      src: "https://static.wixstatic.com/media/dea8ea_9a6a9b63390345b8a17dfd74e3f4ab09.png/v1/fill/w_79,h_46,al_c,q_85,usm_0.66_1.00_0.01/dea8ea_9a6a9b63390345b8a17dfd74e3f4ab09.webp"
    })
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_parallax = _resolveComponent("q-parallax")!
  const _component_q_intersection = _resolveComponent("q-intersection")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_layout = _resolveComponent("q-layout")!

  return (_openBlock(), _createBlock(_component_q_layout, {
    id: "body",
    class: "column no-wrap"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("a", {
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.SmoothScroll('#banner')), ["prevent"]))
            }, [
              _createVNode(_component_q_btn, {
                style: {"font-weight":"bold"},
                unelevated: "",
                label: "Sobre a studioapp"
              })
            ]),
            _createElementVNode("a", {
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.SmoothScroll('#missao')), ["prevent"]))
            }, [
              _createVNode(_component_q_btn, {
                style: {"font-weight":"bold"},
                unelevated: "",
                label: "missão e valores"
              })
            ]),
            _createElementVNode("a", {
              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.SmoothScroll('#expert')), ["prevent"]))
            }, [
              _createVNode(_component_q_btn, {
                style: {"font-weight":"bold"},
                unelevated: "",
                label: "expertises"
              })
            ]),
            _createElementVNode("a", {
              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.SmoothScroll('#portfolio')), ["prevent"]))
            }, [
              _createVNode(_component_q_btn, {
                style: {"font-weight":"bold"},
                unelevated: "",
                label: "portfólio"
              })
            ]),
            _createElementVNode("a", {
              onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.SmoothScroll('#footer')), ["prevent"]))
            }, [
              _createVNode(_component_q_btn, {
                style: {"font-weight":"bold"},
                unelevated: "",
                label: "contato"
              })
            ])
          ])
        ])
      ]),
      _hoisted_5,
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _hoisted_12,
          _hoisted_13,
          _createVNode(_component_q_list, {
            style: {"text-align":"center","font-size":"14px","margin-top":"10px"},
            dense: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_section, null, {
                    default: _withCtx(() => [
                      _hoisted_14
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_q_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_section, null, {
                    default: _withCtx(() => [
                      _hoisted_15
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_q_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_section, null, {
                    default: _withCtx(() => [
                      _hoisted_16
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_q_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_section, null, {
                    default: _withCtx(() => [
                      _hoisted_17
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_q_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_section, null, {
                    default: _withCtx(() => [
                      _hoisted_18
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _hoisted_20,
        _hoisted_21,
        _createElementVNode("div", _hoisted_22, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.expertObjs, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item,
              class: "card",
              style: {"background-color":"#f1aea4","width":"220px","border-top":"black solid 5px"}
            }, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("img", {
                  style: {"width":"62px"},
                  src: item.img
                }, null, 8, _hoisted_24)
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("p", null, _toDisplayString(item.titulo), 1)
              ]),
              _createElementVNode("p", _hoisted_26, _toDisplayString(item.text), 1),
              _hoisted_27
            ]))
          }), 128))
        ])
      ]),
      _createVNode(_component_q_parallax, {
        src: _imports_4,
        speed: 1.40
      }, null, 8, ["speed"]),
      _createElementVNode("div", _hoisted_28, [
        _hoisted_29,
        _hoisted_30,
        _hoisted_31,
        _createElementVNode("div", _hoisted_32, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.portObjs, (item) => {
            return (_openBlock(), _createBlock(_component_q_intersection, {
              id: "intersection",
              key: item,
              transition: "jump-down",
              "transition-duration": "1000",
              class: "example-item"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("img", {
                      width: item.img_size,
                      id: item.rounded,
                      src: item.img
                    }, null, 8, _hoisted_35)
                  ]),
                  _createElementVNode("p", _hoisted_36, _toDisplayString(item.titulo), 1),
                  _createElementVNode("a", {
                    style: {"position":"absolute","margin-top":"60%","text-decoration":"none"},
                    href: item.link,
                    target: "_blank"
                  }, [
                    _withDirectives(_createVNode(_component_q_btn, { color: "deep-orange-8" }, {
                      default: _withCtx(() => [
                        _hoisted_38
                      ]),
                      _: 2
                    }, 1536), [
                      [_vShow, item.btn]
                    ])
                  ], 8, _hoisted_37)
                ])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ])
      ]),
      _hoisted_39,
      _createElementVNode("div", _hoisted_40, [
        _hoisted_41,
        _hoisted_42,
        _hoisted_43,
        _createElementVNode("div", _hoisted_44, [
          _createVNode(_component_q_form, {
            ref: "form",
            "no-wrap": "",
            onSubmit: _ctx.onSubmit,
            class: "row justify-center"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_45, [
                _createVNode(_component_q_input, {
                  filled: "",
                  square: "",
                  modelValue: _ctx.formulario.nome,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formulario.nome) = $event)),
                  label: "Seu nome",
                  "bg-color": "white",
                  "lazy-rules": "",
                  loading: _ctx.loading,
                  rules: [ val => val && val.length > 0 || 'Esse campo deve ser preenchido !']
                }, null, 8, ["modelValue", "loading", "rules"]),
                _createVNode(_component_q_input, {
                  filled: "",
                  square: "",
                  modelValue: _ctx.formulario.telefone,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formulario.telefone) = $event)),
                  label: "Telefone",
                  "lazy-rules": "",
                  "bg-color": "white",
                  mask: "(##) #####-####",
                  loading: _ctx.loading,
                  rules: [ val => val && val.length > 0 || 'Esse campo deve ser preenchido !']
                }, null, 8, ["modelValue", "loading", "rules"]),
                _createVNode(_component_q_input, {
                  filled: "",
                  square: "",
                  type: "email",
                  modelValue: _ctx.formulario.email,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formulario.email) = $event)),
                  label: "Seu Email",
                  "lazy-rules": "",
                  loading: _ctx.loading,
                  "bg-color": "white",
                  rules: [val => !!val || 'Campo obrigatório',
                        val => _ctx.validEmail(val) || 'E-mail inválido']
                }, null, 8, ["modelValue", "loading", "rules"])
              ]),
              _createElementVNode("div", _hoisted_46, [
                _createVNode(_component_q_input, {
                  filled: "",
                  square: "",
                  type: "textarea",
                  "input-style": {resize: 'none', height: '180px'},
                  modelValue: _ctx.formulario.mensagem,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formulario.mensagem) = $event)),
                  label: "Mensagem",
                  loading: _ctx.loading,
                  "lazy-rules": "",
                  "bg-color": "white",
                  rules: [ val => val && val.length > 0 || 'Esse campo deve ser preenchido !']
                }, null, 8, ["modelValue", "loading", "rules"]),
                _createVNode(_component_q_btn, {
                  style: {"width":"50px","align-self":"end","display":"flex","font-size":"12px","background-color":"#30A9EB"},
                  "text-color": "black",
                  size: "10px",
                  label: "Enviar",
                  type: "submit",
                  loading: _ctx.loading
                }, null, 8, ["loading"])
              ])
            ]),
            _: 1
          }, 8, ["onSubmit"])
        ]),
        _hoisted_47,
        _createElementVNode("div", _hoisted_48, [
          _createVNode(_component_q_space),
          _createElementVNode("a", {
            onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.SmoothScroll('#body')), ["prevent"])),
            style: {"cursor":"pointer"}
          }, _hoisted_50),
          _hoisted_51,
          _createElementVNode("div", _hoisted_52, [
            _hoisted_53,
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("p", _hoisted_55, "© studioApp - " + _toDisplayString(new Date().getFullYear()) + " | Todos os direitos reservados", 1)
            ])
          ]),
          _createVNode(_component_q_space)
        ]),
        _hoisted_56
      ])
    ]),
    _: 1
  }))
}